import React from 'react';
import Markdown from 'markdown-to-jsx';
import styles from './homepage-hero.module.scss';
import { useQueryKeyword } from '../../../hooks/use-query-keyword.hook';
import SearchBar from '../search-bar/search-bar';
import { useTranslations } from 'next-intl';
import HomepageHeroModel from '../../../models/homepage/HomepageHero';
import { ApplicationSettings } from '../../../models/settings';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { ReadonlyURLSearchParams } from 'next/navigation';

type Props = {
  homepageHeroData: HomepageHeroModel;
  router: AppRouterInstance;
  searchParams?: ReadonlyURLSearchParams;
  applicationSettings: ApplicationSettings;
  currentLocale: string;
  pathname: string;
  applicationURL: string;
};

// TODO: Refactoring required. Move to a separate file
// Unify with top-menu.tsx
const searchPath = `/search`;

export default function HomepageHero({
  homepageHeroData,
  router,
  pathname,
  searchParams,
  applicationSettings,
  currentLocale,
  applicationURL,
}: Props) {
  const queryKeyword = useQueryKeyword(searchParams);
  const translate = useTranslations(`Common`);

  const heroStyling = {
    backgroundColor: homepageHeroData?.backgroundColor ?? `#060C0A`,
  };

  const heroTextColor = {
    color: homepageHeroData?.headingColor ?? `#ffffff`,
  };

  // TODO: Refactoring required. Move to a separate file
  const isSearchPage = (): boolean => pathname.includes(searchPath);

  const searchHandler = (keyword: string) => {
    if (isSearchPage()) {
      queryKeyword.setKeyword(keyword);
    } else {
      // router.push(`/search?keyword=${keyword}`, { scroll: false });
      // Workaround for router.push acting weird from Page route to App route navigation
      if (typeof window !== 'undefined') {
        const path = `${applicationURL}/${currentLocale}/search?keyword=${keyword}`;
        window.location.href = path;
      }
    }
  };

  return (
    <>
      {homepageHeroData ? (
        <div id='homepage-hero' className={styles[`home-page-hero`]}>
          <div className={styles['home-page-hero-bg']} style={heroStyling}>
            {homepageHeroData?.backgroundImage ? (
              <img src={homepageHeroData.backgroundImage.secureUrl} alt='Hero image' />
            ) : null}
          </div>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <div className={styles[`hero-text`]} style={heroTextColor}>
                  <Markdown>{homepageHeroData?.heading ?? ``}</Markdown>
                </div>
                <div className='col-12 col-md-7 px-0'>
                  <SearchBar
                    idPrefix='typeahead-search'
                    onSearch={searchHandler}
                    initialKeyword={queryKeyword.getKeyword()}
                    cssWrapper='homepage'
                    typeAheadPlaceHolder='e.g. Business Studies and Finance'
                    router={router}
                    translate={translate}
                    applicationSettings={applicationSettings}
                    currentLocale={currentLocale}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
